import toDate from './toDate'; 

const checkChange = (initialValues, params) => {
    console.log('INTIALVALUES: ', initialValues); 
    console.log('PARAMS', params); 
    // if element exists in initial values and hasn't changed in params remove from params
    Object.keys(initialValues).map(el => {
        // check if params element is a date
        let initial = initialValues[el]; 
        let current = params[el]; 
        if (Object.prototype.toString.call(params[el]) === '[object Date]'){
            if (initialValues[el]){
                initial = toDate(initialValues[el]).getTime(); 
            }
            current = params[el].getTime(); 
        }
        // if initial is equal to params element remove it 
        if ((initial != null && current != null) && (initial == current)) {
            delete params[el]; 
        }
    }); 
    // return object  
    return params; 
}

export default checkChange; 